import React from 'react'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import aboutUs from 'custom/static/aboutUs.json'

export default function AboutUs() {
  return (
    <LayoutWithOutAccountCard breadCumKey='ABOUT_US' keyPath='About_Us'>
       <div
        className='new-design-form-style'
        dangerouslySetInnerHTML={{ __html: aboutUs['data'] }}></div>
    </LayoutWithOutAccountCard>
  )
}
